import { render } from "./ClientPeoplePanel.vue?vue&type=template&id=2891ae6c&scoped=true"
import script from "./ClientPeoplePanel.vue?vue&type=script&lang=js"
export * from "./ClientPeoplePanel.vue?vue&type=script&lang=js"

import "./ClientPeoplePanel.vue?vue&type=style&index=0&id=2891ae6c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2891ae6c"]])

export default __exports__